var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4526 14.3185C14.8976 14.3185 14.4477 13.8686 14.4477 13.3136V7.46212C14.4477 5.48997 12.8433 3.88544 10.8711 3.88544C8.8989 3.88544 7.29437 5.48993 7.29437 7.46212V10.8655C7.29437 11.4205 6.84447 11.8704 6.28949 11.8704C5.73451 11.8704 5.28461 11.4205 5.28461 10.8655V7.46212C5.28461 4.38173 7.79066 1.87567 10.8711 1.87567C13.9515 1.87567 16.4575 4.38173 16.4575 7.46212V13.3136C16.4575 13.8686 16.0076 14.3185 15.4526 14.3185Z",
    fill: "#B1B4B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9852 20.4035H4.75688C3.61521 20.4035 2.6897 19.478 2.6897 18.3363V11.2665C2.6897 10.1249 3.61521 9.19934 4.75688 9.19934H16.9852C18.1269 9.19934 19.0524 10.1249 19.0524 11.2665V18.3363C19.0524 19.478 18.1269 20.4035 16.9852 20.4035Z",
    fill: "#FFB636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48331 18.7377H4.37975C4.05355 18.7377 3.78912 18.4733 3.78912 18.1471V11.4561C3.78912 11.1299 4.05355 10.8655 4.37975 10.8655H4.48331C4.80951 10.8655 5.07394 11.1299 5.07394 11.4561V18.1471C5.07394 18.4733 4.80951 18.7377 4.48331 18.7377Z",
    fill: "#FFD469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.e34586b533431806a1bc6e873fef9543.svg";
export { ForwardRef as ReactComponent };